export default {
  ADD_ITEM: 'ADD_ITEM',
  REMOVE_ITEM: 'REMOVE_ITEM',
  ITEM_INPUT: 'ITEM_INPUT',
  FILE_TYPE_CSV: 'text/csv',
  FILE_TYPE_TXT: 'text/txt',
  FILE_ERROR: 'FILE_ERROR',
  INSERT_LIST: 'INSERT_LIST',
};
